export const sso = {
    cognitoSsoUrl: "",
};
